import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { AxiosError } from "axios";
import { errorToast, successToast } from "@telluscompany/design-system";

import { useLocalization } from "@i18n";
import { axiosPutData } from "@shared/api/clients";

import { ADMIN_PERMISSIONS_QUERY_KEY } from "./permissions.queries";
import {
  PutAdminUserPermissionsModule,
  PutAdminUserPermissionsRequest,
} from "./permissions.types";

interface PutBody {
  complexId: string;
  structureId: string;
  modules: PutAdminUserPermissionsModule[];
}

export const putUserPermissions = async ({
  userId,
  ...body
}: PutAdminUserPermissionsRequest): Promise<void> => {
  await axiosPutData<void, PutBody>(
    `v1/admin/users/${userId}/permissions`,
    body,
  );
};

export const usePutUserPermissionsMutation = () => {
  const queryClient = useQueryClient();
  const { translate } = useLocalization();

  return useMutation({
    mutationFn: putUserPermissions,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ADMIN_PERMISSIONS_QUERY_KEY,
        exact: false,
      });
      successToast({ description: translate("common.editSuccess") });
    },
    onError: (error: AxiosError) => {
      errorToast({
        description: error.parsedMessage ?? translate("common.errorEditing"),
      });
    },
  });
};
